import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthUser } from '../../features/auth';
import Layout from '../../features/layout/Layout';

const PrivateRoute = () => {
  const user = useSelector(selectAuthUser);
  const storeduser = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();

  if (!user && !storeduser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default PrivateRoute;
